import { Box } from "@mui/system"
import React, { useEffect, useState } from "react"
import TestimonialsLight from "./sections/TestimonialsLight"
import PaddedContainer from "./ui/PaddedContainer"
import { getQueryParam } from "../utils/queryParams"

type AffiliateInfo = {
  PARTNER_ID?: string
  NOTIFICATION_BAR_TEXT?: string
  COUPON_CODE?: string
  PARTNERNAME?: string
  PARTNERQUOTE?: string
  PARTNERTITLE?: string
  PRELOAD_IMAGES?: string[]
}
const AffiliateQuote = () => {
  const isInflection =
    getQueryParam("utm_source").toLowerCase() === "inflektion"
  const affiliateId = getQueryParam("utm_campaign")
  if (!isInflection || !affiliateId) {
    return <></>
  }

  const [affiliateInfo, setAffiliateInfo] = useState<AffiliateInfo | undefined>(
    undefined
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const aId =
    process.env.GATSBY_SENSAI_SERVER_URL === "https://app.sens.ai" ? 47 : 47
  useEffect(() => {
    fetch(
      `https://trainingbrainsystems.com/partner/1/${aId}/${affiliateId}.json`
    )
      .then(async r => r.json())
      .then(r => {
        r.ONPAGE_TEXT_EDITS.forEach((t: any) => {
          const info = JSON.parse(t.value)
          r[info.selector] = info.text_change
        })
        setAffiliateInfo(r)
        setIsLoading(false)
      })
      .catch(() => {})
  }, [])

  if (!affiliateInfo || !affiliateInfo.PARTNERQUOTE) {
    return <></>
  }

  return (
    <Box>
      <PaddedContainer padding="2rem 1rem 2rem 1rem">
        <TestimonialsLight
          isInitLoading={isLoading}
          sectionId={`affiliate-${affiliateId}`}
          forceNoTruncate={true}
          testimonials={[
            {
              id: `affiliate-${affiliateId}-quote`,
              imgUrl:
                (affiliateInfo.PRELOAD_IMAGES?.length ?? 0) > 0
                  ? affiliateInfo.PRELOAD_IMAGES![0]
                  : undefined,
              author: affiliateInfo.PARTNERNAME ?? "",
              company: affiliateInfo.PARTNERTITLE ?? "",
              quote: affiliateInfo.PARTNERQUOTE!,
            },
          ]}
          startIndex={0}
          backgroundColor={undefined}
        />
      </PaddedContainer>
    </Box>
  )
}

export default AffiliateQuote
